import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import logo from "../../../../assest/images/logo.png";
import { Box } from "@mui/material";

function Footer() {
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          left: 20,
          fontSize: "14px",
          fontWeight: 400,
          fontFamily: "Roboto, sans-serif",
          color: "#333",
         
        }}
      >
        <span>
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
              fontSize:"13px"
            }}
          >
            Privacy Policy
          </a>
        </span>
      </Box>
      <MaterialBox sx={{ textAlign: "right",  position: "absolute",
          bottom: 20,
          right: 20}}>
        <MaterialTypography variant="body2" color="dark" mr={1}>
          Developed by{" "}
          <a href="" style={{ textDecoration: "none" }}>
            KEELIS
          </a>{" "}
          <img
            style={{ width: 18, height: 12 }}
            src={logo}
            alt="image not found"
          ></img>
        </MaterialTypography>
      </MaterialBox>
    </>
  );
}

export default Footer;
